module.exports = __webpack_public_path__ + "img/card-pay_black.e1a97c34.svg";